import { render, staticRenderFns } from "./SendingList.vue?vue&type=template&id=484550e0&scoped=true"
import script from "./SendingList.vue?vue&type=script&lang=js"
export * from "./SendingList.vue?vue&type=script&lang=js"
import style0 from "./SendingList.vue?vue&type=style&index=0&id=484550e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484550e0",
  null
  
)

export default component.exports